import { extend, localize } from 'vee-validate'
import { max, min, required, min_value, max_value } from 'vee-validate/dist/rules'
import pt_BR from 'vee-validate/dist/locale/pt_BR'
import _ from 'lodash'
import moment from 'moment'

localize('pt_BR', pt_BR)

const carregarExtends = () => {
  extend('required', { ...required, message: 'Campo obrigatório.' })
  extend('min_value', {
    ...min_value,
    message: (field, params) => {
      return 'O valor do campo deve ser no mínimo ' + params['min'] + '.'
    }
  })
  extend('max_value', {
    ...max_value,
    message: (field, params) => {
      return 'O valor do campo deve ser no máximo ' + params['max'] + '.'
    }
  })

  extend('cpf_cnpj', {
    validate (value) {
      return isValidCPF(value) || isValidCNPJ(value)
    },
    message: 'CPF/CNPJ inválido',
    computesRequired: true
  })

  extend('cpf', {
    validate (value) {
      return isValidCPF(value)
    },
    message: 'CPF inválido',
    computesRequired: true
  })

  extend('cnpj', {
    validate (value) {
      return isValidCNPJ(value)
    },
    message: 'CNPJ inválido',
    computesRequired: true
  })

  extend('max', {
    ...max,
    message: (field, params) => {
      return 'Limite máximo de ' + params.length + ' caracteres.'
    }
  })

  extend('min', {
    ...min,
    message: (field, params) => {
      return 'Limite mínimo de ' + params.length + ' caracteres.'
    }
  })

  extend('telefone', {
    validate (value) {
      return isValidTelefone(value)
    },
    message: 'Número de telefone inválido',
    computesRequired: true
  })

  extend('email', {
    validate (value) {
      return isValidEmail(value)
    },
    message: 'E-mail inválido',
    computesRequired: true
  })

  extend('car', {
    validate (value) {
      return isValidCar(value)
    },
    message: 'Número do CAR inválido',
    computesRequired: true
  })

  extend('max', {
    ...max,
    message: (field, params) => {
      return 'Limite máximo de ' + params.length + ' caracteres.'
    }
  })

  extend('email_confirmation', {
    params: ['target'],
    validate (value, { target }) {
      return value === target
    },
    message: 'Os e-mails informados devem ser iguais'
  })

  extend('password_confirmation', {
    params: ['target'],
    validate (value, { target }) {
      return value === target
    },
    message: 'As senhas informadas devem ser iguais'
  })

  extend('min', {
    ...min,
    message: (field, params) => {
      return 'Limite mínimo de ' + params.length + ' caracteres.'
    }
  })

  extend('min_value', {
    validate (value, { minValue }) {
      return value >= minValue
    },
    message: 'O valor mínimo não deve ser menor que {minValue} ',
    params: ['minValue'],
    computesRequired: true
  })

  extend('apenasLetras', {
    validate (value) {
      return isOnlyLetters(value)
    },
    message: 'O {_field_} deve ter apenas letras',
    computesRequired: true
  })

  extend('apenasNumeros', {
    validate (value) {
      return isOnlyNumbers(value)
    },
    message: 'O {_field_} deve ter apenas números',
    computesRequired: true
  })

  /* Validação de documentos obrigatório dos cadastro */
  let errorMessage = ''
  extend('documentosObrigatorios', {
    validate (values) {
      if (!values) {
        return false
      }

      const { documentos, documentosObrigatorios } = values

      const errors = []
      errorMessage = '\n\n'

      for (let i = 0; i < documentosObrigatorios.length; i++) {
        const docFound = _.find(documentos, item => item.tipoDocumento.codigo === documentosObrigatorios[i].codigo)

        if (!docFound) {
          errors.push(documentosObrigatorios[i].descricao + ' é obrigatório.')
          errorMessage += '  - ' + documentosObrigatorios[i].descricao + ' é obrigatório \n\n'
        }
      }

      return errors.length > 0 ? errorMessage : true
    }
  })

  extend('dateAfterToday', {
    message: `A data selecionada deve ser superior a ${moment().format('DD/MM/YYYY')}.`,
    validate: (value) => {
      return moment(value).isAfter(moment())
    }
  })

  extend('notZero', {
    message: 'O valor deve ser maior que zero',
    validate: value => value !== 0
  })

  extend('perfis_setor_unique', {
    validate: (value) => {
      return perfisHasSingleSetor(value)
    },
    message: 'Não é possível inserir dois perfis de um mesmo setor.'
  })

  extend('perfis_externo', {
    validate: (value) => {
      return hasSetorExterno(value)
    },
    message: 'Não é possível ter um perfil externo e um perfil interno vinculados a um mesmo usuário.'
  })

  extend('hasTelefone', {
    message: 'Campo obrigatório',
    validate (values) {
      const { telefones } = values

      if (!telefones || !telefones.length || telefones.length <= 0) {
        return false
      }

      return true
    },
    computesRequired: true
  })
  
  extend('senhaComplexa', {
    validate(value) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[A-Za-z\d\W\S]{8,}$/
      return regex.test(value)
    },
    message: 'A senha deve ter pelo menos 8 caracteres, incluindo maiúsculas, minúsculas, números e caracteres especiais.'
  })
}

function isValidEmail (email) {
  var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(String(email).toLowerCase())
}

function isValidCar (car) {
  if (car === null || car === undefined) {
    return false
  }

  var reciboCar = car.toString().replace(/[-_./]/g, '')
  if (reciboCar.length !== 41) {
    return false
  }

  const res = reciboCar.split('')
  if (res[0] !== 'P' || res[1] !== 'A') {
    return false
  }

  return true
}

function perfisHasSingleSetor (perfis) {
  const codigosSetor = perfis.map(perfil =>
    JSON.parse(perfil).setor != null ? JSON.parse(perfil).setor.codigo : '')

  for (let i = 0; i < codigosSetor.length; i++) {
    for (let j = i + 1; j < codigosSetor.length; j++) {
      if (codigosSetor[i] === codigosSetor[j]) {
        return false
      }
    }
  }
  return true
}

function hasSetorExterno (perfis) {
  const codigosSetor = perfis.map(perfil =>
    JSON.parse(perfil).setor != null ? JSON.parse(perfil).setor.codigo : '')

  const hasExterno = codigosSetor.includes('EXTERNO')

  for (let i = 0; i < codigosSetor.length; i++) {
    if (codigosSetor[i] !== 'EXTERNO' && hasExterno) {
      return false
    }
  }
  return true
}

function isOnlyLetters (string) {
  var re = /^[a-zA-Z\u00C0-\u00FF\s]*$/
  return re.test(string)
}

function isOnlyNumbers (number) {
  var re = /^(\(?\+?[0-9]*\)?)?[0-9_\- ()]*$/g
  return re.test(number)
}

// Validação do CPF
function isValidCPF (cpf) {
  if (cpf === undefined || cpf === null) return false

  if ((cpf = cpf.replace(/[^\d]/g, '')).length !== 11) return false

  const cpfInvalidos = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999'
  ]

  if (cpfInvalidos.indexOf(cpf) > -1) return false

  let r,
    i
  let s = 0
  for (i = 1; i <= 9; i++) s += parseInt(cpf[i - 1]) * (11 - i)
  r = (s * 10) % 11
  if (r === 10 || r === 11) r = 0
  if (r !== parseInt(cpf[9])) return false
  s = 0
  for (i = 1; i <= 10; i++) s += parseInt(cpf[i - 1]) * (12 - i)
  r = (s * 10) % 11

  if (r === 10 || r === 11) r = 0

  if (r !== parseInt(cpf[10])) return false

  return true
}

function isValidCNPJ (cnpjFull) {
  if (cnpjFull === null || cnpjFull === undefined) {
    return false
  }
  var cnpj = cnpjFull.toString().replace(/[-_./]/g, '')

  if (cnpj.length !== 14) {
    return false
  }

  let i
  const c = cnpj.substr(0, 12)
  const dv = cnpj.substr(12, 2)
  let d1 = 0

  for (i = 0; i < 12; i++) {
    d1 += c.charAt(11 - i) * (2 + (i % 8))
  }

  if (d1 === 0) {
    return false
  }

  d1 = 11 - (d1 % 11)

  if (d1 > 9) {
    d1 = 0
  }

  if (parseInt(dv.charAt(0)) !== d1) {
    return false
  }

  d1 *= 2

  for (i = 0; i < 12; i++) {
    d1 += c.charAt(11 - i) * (2 + ((i + 1) % 8))
  }

  d1 = 11 - (d1 % 11)

  if (d1 > 9) {
    d1 = 0
  }

  if (parseInt(dv.charAt(1)) !== d1) {
    return false
  }

  return true
}

function isValidTelefone (telefone) {
  // (##) #####-####
  const regexFixo = /[(]\d\d[)] \d\d\d\d[-]\d\d\d\d/g
  if (telefone.match(regexFixo)) {
    return true
  }
  const regexCelular = /[(]\d\d[)] \d\d\d\d\d[-]\d\d\d\d/g
  if (telefone.match(regexCelular)) {
    return true
  }
  return false
}

export default carregarExtends
